
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import IconOeamtcClose from '@/components/icons/icon-oeamtc-close.svg';
import IconCheck from '@components/icons/icon-check.svg';

@Component({
  name: 'BaseModal',
  components: {
    IconOeamtcClose,
    IconCheck,
  }
})
export default class BaseModal extends Vue {
  @Prop({ default: false })
  private open: boolean;

  @Prop({ default: false })
  private submitDisabled: boolean;

  private close() {
    this.$emit('close');
  }

  private submit() {
    this.$emit('submit');
  }
}
